// extracted by mini-css-extract-plugin
export default {"inputNumber":"InputNumber_inputNumber__zSAKN"};